export default __webpack_public_path__ + "static/media/eyekillercards_from_watcher_of_threads.e6b1c802.jpg";